import tw from 'twin.macro';
import { Link } from 'gatsby';

const CollapseLink = tw(
  Link
)`inline-flex items-center space-x-1 py-3 px-4 bg-white text-blue rounded-lg font-bold justify-center shadow hover:(bg-blue-800 text-white)`;

export default CollapseLink;
